import { LitElement as d, css as u, unsafeCSS as f, html as p } from "lit";
import { property as g } from "lit/decorators/property.js";
const m = ":host{display:inline-block;font-size:13px;line-height:20px;font-family:Segoe UI,Lucida Sans,Arial,sans-serif;color:#111;contain:content}:host([hidden]){display:none!important}:host([level=warn i]){color:#555}:host([level=suggest i]){color:#bf8800}:host([level=error i]){color:#cc0017}:host([level=warn]){color:#555}:host([level=suggest]){color:#bf8800}:host([level=error]){color:#cc0017}.icon{height:12px;width:12px;padding-right:4px;margin-bottom:-1px}", w = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2012%2012'%3e%3cstyle%20id='style3'%3e%20.st0{fill:%23fff}.st1{fill:%23c00}%20%3c/style%3e%3cg%20id='g5'%3e%3cpath%20class='st1'%20d='M6%20.9c2.8%200%205.1%202.3%205.1%205.1S8.8%2011.1%206%2011.1.9%208.8.9%206%203.2.9%206%20.9m0-1C2.7-.1-.1%202.7-.1%206s2.7%206.1%206.1%206.1%206.1-2.7%206.1-6.1S9.3-.1%206-.1z'%20id='path9'/%3e%3c/g%3e%3cg%20id='g11'%3e%3cpath%20class='st0'%20id='rect13'%20d='M5.5%202.5h1v4h-1z'/%3e%3cpath%20class='st1'%20d='M6%203v3-3m1-1H5v5h2V2z'%20id='path15'/%3e%3c/g%3e%3cg%20id='g17'%3e%3cpath%20class='st0'%20id='rect19'%20d='M5.5%208.5h1v1h-1z'/%3e%3cpath%20class='st1'%20id='polygon21'%20d='M7%208H5v2h2V8z'/%3e%3c/g%3e%3c/svg%3e", y = "data:image/svg+xml,%3csvg%20id='Ebene_1'%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2024%2024'%3e%3cstyle%3e%20.st0{fill:%23bf8800}%20%3c/style%3e%3cpath%20class='st0'%20d='M12%20.8l11%2019.8v1.3H1v-1.3L12%20.8zm.8-.6h-1.6L0%2020v3h24v-3L12.8.2z'/%3e%3cpath%20class='st0'%20d='M11%208h2v8h-2zm0%2010h2v2h-2z'/%3e%3c/svg%3e", x = "data:image/svg+xml,%3csvg%20xmlns='http://www.w3.org/2000/svg'%20viewBox='0%200%2012%2012'%3e%3cpath%20class='st1'%20d='M6%20.9c2.8%200%205.1%202.3%205.1%205.1S8.8%2011.1%206%2011.1.9%208.8.9%206%203.2.9%206%20.9m0-1C2.7-.1-.1%202.7-.1%206s2.7%206.1%206.1%206.1%206.1-2.7%206.1-6.1S9.3-.1%206-.1z'%20fill='%23555'/%3e%3cpath%20d='M6%209V6v3m-1%201h2V5H5v5zm2-8H5v2h2z'%20class='st1'%20fill='%23555'/%3e%3c/svg%3e";
var b = Object.defineProperty, z = Object.getOwnPropertyDescriptor, v = (s, e, o, l) => {
  for (var r = l > 1 ? void 0 : l ? z(e, o) : e, i = s.length - 1, a; i >= 0; i--)
    (a = s[i]) && (r = (l ? a(e, o, r) : a(r)) || r);
  return l && r && b(e, o, r), r;
}, t;
const c = (t = class extends d {
  static parseLevel(e) {
    if (e) {
      const o = Object.keys(h).find(
        (l) => l.toLowerCase() === e.toLowerCase()
      );
      return o && h[o];
    }
  }
  static get styles() {
    return [
      u`
                ${f(m)}
            `
    ];
  }
  // prettier-ignore
  render() {
    return p`${this.iconToUse && p`<img class="icon" src="${this.iconToUse}">`}${this.message}`;
  }
  get iconToUse() {
    return this.icon || this._defaultIconPath;
  }
  shouldUpdate(e) {
    return e.has("level") && (this._defaultIconPath = this.iconForLevel, !this.icon) ? !0 : super.shouldUpdate(e);
  }
  get iconForLevel() {
    switch (t.parseLevel(this.level)) {
      case "warn":
        return x;
      case "suggest":
        return y;
      case "error":
        return w;
      default:
        return null;
    }
  }
}, t.ID = "sd-field-validation-message", t.levelConverter = {
  fromAttribute(e) {
    return t.parseLevel(e);
  },
  toAttribute(e) {
    return e && e.toLowerCase();
  }
}, t);
v([
  g({ type: String, attribute: !0 })
], c.prototype, "message", 2);
v([
  g({ type: String, attribute: !0 })
], c.prototype, "icon", 2);
v([
  g({
    converter: c.levelConverter,
    reflect: !0
  })
], c.prototype, "level", 2);
let n = c;
var h = /* @__PURE__ */ ((s) => (s.Warn = "warn", s.Suggest = "suggest", s.Error = "error", s))(h || {});
customElements.get(n.ID) || customElements.define(n.ID, n);
export {
  h as ValidationLevel,
  n as default
};
//# sourceMappingURL=field-validation-message.mjs.map
